module.exports = __webpack_public_path__ + "img/alarm-system.9b2e2bfa.png";